import React from 'react';
import {ScrollView} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';
import Text from '/component/base/Text';

import Complex from './Complex';
import Readonly from './Readonly';
import Simple from './Simple';

storiesOf('base', module).add('ListItem', () => (
  <ScrollView>
    <FlexView>
      <Spacing size={20}>
        <Heading level={1}>List Item Component</Heading>
        <Spacer size={16} />
        <Text>
          The <Code>{'ListItem'}</Code> component accepts{' '}
          <Code>{'prefix'}</Code>, <Code>{'label'}</Code>,{' '}
          <Code>{'suffix'}</Code>, <Code>{'readonly'}</Code>, and{' '}
          <Code>{'onPress'}</Code> props.
        </Text>
        <Spacer size={10} />
        <Text>
          The parent component determines the horizontal padding of{' '}
          <Code>{'ListItem'}</Code> to allow for added flexibility.
        </Text>
      </Spacing>
      <Simple />
      <Spacer size={16} />
      <Complex />
      <Spacer size={16} />
      <Readonly />
    </FlexView>
  </ScrollView>
));
